export default {
  GET_ITEMS(state) {
    console.log("invoices:",state.invoices);
    return state.invoices
  },

}
